<template>
  <v-simple-table class="mb-10">
    <template v-slot:default>
      <tbody>
        <tr v-for="item in details" :key="item.name">
          <td>
            <b>{{ item.name }}</b>
          </td>
          <td>{{ item.value }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  props: {
    item: Object, // unit object passed from UnitDetails component
  },
  mounted: async function () {
    await this.getQualifications();
    this.section = this.$route.params.section;
    this.id = this.$route.query.id || this.$route.query.unitId;

    this.getUnit();
  },
  data() {
    return {
      details: [],
      qualifications: [],
      mapper: [
        {
          name: "Unit Name",
          mapTo: "name",
        },
        {
          name: "Unit Code",
          mapTo: "code",
        },
        {
          name: "UAN",
          mapTo: "uan",
        },
        {
          name: "Unit Description",
          mapTo: "description",
        },
        {
          name: "Unit Type",
          mapTo: "type",
        },
        {
          name: "Unit Level",
          mapTo: "level",
        },
        {
          name: "Unit Credits",
          mapTo: "credits",
        },
        {
          name: "Unit Status",
          mapTo: "status",
        },
        {
          name: "Unit Number",
          mapTo: "number",
        },
        {
          name: "Unit Note",
          mapTo: "note",
        },
        {
          name: "Unit Start Date",
          mapTo: "startDate",
        },
        {
          name: "Unit Review Date",
          mapTo: "reviewDate",
        },
        {
          name: "Total Qualification Time",
          mapTo: "tqt",
        },
        {
          name: "Grading Criterion",
          mapTo: "name",
        },
        {
          name: "Grading Language",
          mapTo: "gradingCriterion",
        },
        {
          name: "Minimum Guided Learning Hours",
          mapTo: "minimumHour",
        },
        {
          name: "Number of Resits",
          mapTo: "noOfResits",
        },
        {
          name: "Delivery Mode",
          mapTo: "deliveryMode",
        },
        {
          name: "Learning Outcomes",
          mapTo: "learningOutcomes",
        },
        {
          name: "Courses Associated With",
          mapTo: "coursesAssociatedWith",
        },
      ],
    };
  },
  methods: {
    getQualifications: function () {
      const promise = fetch(`${process.env.VUE_APP_ROOT_API}/qualifications`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.qualifications = data.qualifications;
        })
        .catch((error) => {
          console.error(error);
        });

      return promise;
    },
    getUnit: function () {
      // execute for new unit summary
      if (this.item) {
        this.writeToTable(this.item);
        return;
      }

      // execute for existing unit summary
      fetch(`${process.env.VUE_APP_ROOT_API}/units/${this.id}`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.writeToTable(data.unit);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    writeToTable: function (item) {
      // to arrange the details to summary table in the desirable order
      this.mapper.map((key) => {
        Object.keys(item).map((i) => {
          if (key.mapTo == i) {
            if (key.mapTo == "coursesAssociatedWith") {
              let selected = [];

              for (let k = 0; k < item[i].length; k++) {
                for (let j = 0; j < this.qualifications.length; j++) {
                  if (item[i][k] == this.qualifications[j]._id) {
                    selected.push(this.qualifications[j].code);
                  }
                }
              }

              this.details.push({ name: key.name, value: selected.join(", ") });
            } else {
              this.details.push({ name: key.name, value: item[i] });
            }
          }
        });
      });
    },
  },
};
</script>

<style scoped>
</style>